/* Clarène PDP (cps-) · comportamiento de la ficha.
   Sin dependencias. No calcula precios ni toca el carrito: el formulario usa el AJAX del tema (theme.AjaxProduct),
   igual que la ficha actual, para que Kaching y el carrito lateral de Clarène funcionen exactamente igual. */
(function () {
  'use strict';
  if (window.__cpsInit) return;
  window.__cpsInit = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Cuentas atrás (una sola vez por segundo para todas) ---------- */
  var timers = [];
  function tick() {
    var now = Date.now();
    timers.forEach(function (t) {
      var left = t.end - now;
      if (left <= 0) { t.done(); return; }
      var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      t.draw(d, h, m, sec);
    });
    timers = timers.filter(function (t) { return t.end > now; });
    if (!timers.length && tickId) { clearInterval(tickId); tickId = null; }
  }
  var tickId = null;
  function addTimer(t) { timers.push(t); if (!tickId) tickId = setInterval(tick, 1000); tick(); }

  function initBarCountdowns() {
    $$('[data-cps-countdown]').forEach(function (el) {
      if (el.__cps) return; el.__cps = 1;
      var end = Date.parse(el.getAttribute('data-cps-countdown'));
      if (isNaN(end) || end <= Date.now()) { el.hidden = true; return; }
      el.hidden = false;
      var dd = $('[data-d]', el), hh = $('[data-h]', el), mm = $('[data-m]', el), ss = $('[data-s]', el);
      addTimer({ end: end,
        draw: function (d, h, m, s) { dd.textContent = pad(d); hh.textContent = pad(h); mm.textContent = pad(m); ss.textContent = pad(s); },
        done: function () {
          el.hidden = true;
          if (el.getAttribute('data-cps-hide-bar') === 'true') { var sec = el.closest('.shopify-section'); if (sec) sec.style.display = 'none'; }
        } });
    });
  }

  /* ---------- Bloque de urgencia: barra + cuenta atrás ----------
     Modos (ajuste «Estado de la cuenta atrás»):
       off   → sin cuenta atrás (no se anuncia ninguna caducidad).
       fixed → promoción con fecha fija: cuenta hasta «Fin de la promoción».
       cycle → ciclos consecutivos de N horas desde una fecha de inicio global. El fin del ciclo actual se calcula
               solo con esa fecha y la duración (inicio + k·N), así que todos los visitantes ven el mismo tiempo y
               recargar no lo reinicia. No usa cookies ni localStorage. Al terminar un ciclo empieza el siguiente.
     Nunca usa la fecha de fin de la campaña general. Fechas: «2026-11-27 23:59», «2026-11-27T23:59» o ISO completo. */
  function parseDate(v, tz) {
    v = (v || '').trim();
    if (!v) return NaN;
    var m = v.match(/^(\d{4}-\d{2}-\d{2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?\s*(Z|[+-]\d{2}:?\d{2})?$/i);
    if (!m) return Date.parse(v);
    var zone = m[5] || (tz || '+01:00').trim();
    if (/^[+-]\d{4}$/.test(zone)) zone = zone.slice(0, 3) + ':' + zone.slice(3);
    var hh = m[2] ? (m[2].length < 2 ? '0' : '') + m[2] : '00';
    return Date.parse(m[1] + 'T' + hh + ':' + (m[3] || '00') + ':' + (m[4] || '00') + zone);
  }
  // Periodo activo de la cuenta atrás en el instante «now»: { start, end } o null
  function cdPeriod(c, now) {
    if (c.mode === 'fixed') {
      if (isNaN(c.pEnd) || c.pEnd <= now || (!isNaN(c.pStart) && c.pStart > now)) return null;
      return { start: c.pStart, end: c.pEnd };
    }
    if (c.mode === 'cycle') {
      var len = c.hours * 3600000;
      if (isNaN(c.cStart) || !(len > 0) || now < c.cStart) return null;
      if (!isNaN(c.cEnd) && now >= c.cEnd) return null;
      var k = Math.floor((now - c.cStart) / len);
      var s = c.cStart + k * len, e = s + len;
      if (!isNaN(c.cEnd) && e > c.cEnd) e = c.cEnd; // el último ciclo se acorta si la serie termina antes
      return { start: s, end: e };
    }
    return null;
  }
  window.__cpsCdPeriod = cdPeriod; // solo para pruebas
  function initCampaigns() {
    $$('[data-cps-campaign]').forEach(function (el) {
      if (el.__cps) return; el.__cps = 1;
      var g = function (a) { return el.getAttribute(a) || ''; };
      var tz = g('data-tz');
      var c = {
        mode: g('data-cd') || (g('data-pend') ? 'fixed' : 'off'),
        pStart: parseDate(g('data-pstart'), tz), pEnd: parseDate(g('data-pend'), tz),
        cStart: parseDate(g('data-cstart'), tz), hours: parseFloat(g('data-chours')) || 96, cEnd: parseDate(g('data-cend'), tz)
      };
      var campStart = parseDate(g('data-start'), tz), campEnd = parseDate(g('data-end'), tz);
      var hideEnd = g('data-hide-end') === 'true';
      var fill = $('[data-cps-fill]', el), bar = $('.cps-camp__bar', el);
      var right = $('.cps-camp__r', el), time = $('[data-cps-camp-time]', el);
      var fmt = g('data-fmt') || 'compact', L = { d: g('data-ld') || 'd', h: g('data-lh') || 'h', m: g('data-lm') || 'min', s: g('data-ls') || 's' };
      var timeBar = fill && g('data-mode') === 'time';
      function drawBar(per, now) {
        if (!timeBar) return;
        var s = per && !isNaN(per.start) ? per.start : campStart, e = per && !isNaN(per.start) ? per.end : campEnd;
        if (isNaN(s) || isNaN(e) || e <= s) return;
        var p = Math.max(0, Math.min(1, (now - s) / (e - s)));
        fill.style.setProperty('--prog', (p * 100).toFixed(2) + '%');
        if (bar) bar.setAttribute('aria-valuenow', Math.round(p * 100));
      }
      function fmtTime(d, h, m, sec) {
        if (fmt === 'hours') return pad(d * 24 + h) + ':' + pad(m) + ':' + pad(sec);
        if (fmt === 'units') return (d > 0 ? d + ' ' + L.d + ' ' : '') + pad(h) + ' ' + L.h + ' ' + pad(m) + ' ' + L.m + ' ' + pad(sec) + ' ' + L.s;
        return (d > 0 ? d + L.d + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      }
      // Arranca (o continúa) la cuenta atrás del periodo vigente; al terminar, pasa al siguiente ciclo
      function run() {
        var now = Date.now(), per = cdPeriod(c, now);
        drawBar(per, now);
        if (!per) {
          if (right) right.hidden = true;
          if (c.mode === 'fixed' && hideEnd && !isNaN(c.pEnd) && c.pEnd <= now) el.hidden = true;
          return;
        }
        if (!right || !time) return;
        right.hidden = false;
        addTimer({ end: per.end,
          draw: function (d, h, m, sec) { time.textContent = fmtTime(d, h, m, sec); if (timeBar) drawBar(per, Date.now()); },
          done: function () { setTimeout(run, 50); } });
      }
      run();
    });
  }

  /* ---------- Envío hoy / mañana / lunes (hora de Madrid) ---------- */
  function initShip() {
    $$('[data-cps-ship]').forEach(function (el) {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Madrid', weekday: 'short', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
        var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; };
        var day = get('weekday'), hour = parseInt(get('hour'), 10), cut = parseInt(el.getAttribute('data-cutoff'), 10) || 15;
        var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(day) !== -1;
        var txt = el.getAttribute('data-tomorrow');
        if (weekday && hour < cut) txt = el.getAttribute('data-today');
        else if (day === 'Fri' || day === 'Sat' || day === 'Sun') txt = el.getAttribute('data-monday');
        var t = $('[data-cps-ship-text]', el); if (t && txt) t.textContent = txt;
      } catch (e) { /* sin Intl: se queda el texto por defecto */ }
    });
  }

  /* ---------- Galería ---------- */
  function initGallery(root) {
    var g = $('[data-cps-gallery]', root);
    if (!g || g.__cps) return; g.__cps = 1;
    var track = $('[data-cps-gal-track]', g);
    var slides = $$('[data-cps-slide]', g);
    var thumbs = $$('[data-cps-thumb]', g);
    var thumbsBox = $('[data-cps-gal-thumbs]', g);
    var current = 0;
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && thumbsBox) {
        var l = t.offsetLeft - thumbsBox.offsetLeft, r = l + t.offsetWidth;
        if (l < thumbsBox.scrollLeft || r > thumbsBox.scrollLeft + thumbsBox.clientWidth) thumbsBox.scrollTo({ left: l - 10, behavior: reduced ? 'auto' : 'smooth' });
      }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-cps-thumb')); }); });
    var prev = $('[data-cps-gal-prev]', g), next = $('[data-cps-gal-next]', g);
    if (prev) prev.addEventListener('click', function () { go(current === 0 ? slides.length - 1 : current - 1); });
    if (next) next.addEventListener('click', function () { go(current === slides.length - 1 ? 0 : current + 1); });
    if ('IntersectionObserver' in window && slides.length > 1) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) setActive(+e.target.getAttribute('data-cps-slide')); });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    $$('[data-cps-dismiss-btn]', g).forEach(function (b) {
      b.addEventListener('click', function () { var c = b.closest('[data-cps-dismiss]'); if (c) c.remove(); });
    });
  }

  /* ---------- Carruseles (testimonios, ingredientes) ---------- */
  function initCarousel(c) {
    if (c.__cps) return; c.__cps = 1;
    var track = $('[data-cps-track]', c);
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    var prev = $('[data-cps-prev]', c), next = $('[data-cps-next]', c);
    var prog = $('[data-cps-prog]', c);
    var dotsBox = c.hasAttribute('data-dots') ? $('[data-cps-dots]', c) : null;
    var step = function () { var it = items[0]; if (!it) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap) || 0; return it.getBoundingClientRect().width + gap; };
    var pages = 1, dots = [];
    function buildDots() {
      if (!dotsBox) return;
      var per = Math.max(1, Math.round(track.clientWidth / step()));
      var n = Math.max(1, items.length - per + 1);
      if (n === pages && dots.length) return;
      pages = n; dotsBox.innerHTML = ''; dots = [];
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', String(i + 1));
        (function (k) { d.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: reduced ? 'auto' : 'smooth' }); }); })(i);
        dotsBox.appendChild(d); dots.push(d);
      }
      dotsBox.hidden = n < 2;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      if (prog) {
        var ratio = track.clientWidth / Math.max(track.scrollWidth, 1);
        prog.style.width = Math.max(ratio * 100, 12) + '%';
        var p = max > 0 ? x / max : 0;
        prog.style.transform = 'translateX(' + (p * (100 / Math.max(ratio, 0.12) - 100)) + '%)';
      }
      if (dots.length) { var idx = Math.round(x / step()); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === Math.min(idx, dots.length - 1)); }); }
      var ctl = c.querySelector('.cps-car__ctl, .cps-dots-ctl');
      if (ctl) ctl.style.visibility = max > 2 ? '' : 'hidden';
    }
    var raf = 0;
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; update(); }); }, { passive: true });
    // Salta pieza a pieza aunque tengan anchos distintos (vídeo solo / vídeo + tarjeta)
    function go(dir) {
      var x = track.scrollLeft, base = track.getBoundingClientRect().left - x, target = null;
      var lefts = items.map(function (it) { return it.getBoundingClientRect().left - base - (parseFloat(getComputedStyle(track).paddingLeft) || 0); });
      if (dir > 0) { for (var i = 0; i < lefts.length; i++) { if (lefts[i] > x + 4) { target = lefts[i]; break; } } }
      else { for (var j = lefts.length - 1; j >= 0; j--) { if (lefts[j] < x - 4) { target = lefts[j]; break; } } }
      if (target === null) target = dir > 0 ? track.scrollWidth : 0;
      track.scrollTo({ left: Math.max(0, target), behavior: reduced ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    /* Altura adaptable (solo móvil, opcional): el carril mide lo que la tarjeta más alta de las que se VEN
       (la activa y la que asoma). Así un vídeo sin reseña no deja el hueco de la reseña más larga.
       Sin márgenes negativos: solo se fija la altura del carril; las tarjetas no cambian. */
    var autoH = c.hasAttribute('data-auto-h') && window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
    var hRaf = 0, lastH = 0;
    function fitHeight() {
      hRaf = 0;
      if (!autoH || !autoH.matches) { if (track.hasAttribute('data-autoh')) { track.removeAttribute('data-autoh'); track.style.height = ''; lastH = 0; } return; }
      var tr = track.getBoundingClientRect(), h = 0;
      items.forEach(function (it) { var r = it.getBoundingClientRect(); if (r.right > tr.left + 1 && r.left < tr.right - 1) h = Math.max(h, r.height); });
      if (!h) return;
      var cs = getComputedStyle(track);
      h = Math.ceil(h + (parseFloat(cs.paddingBottom) || 0) + (cs.boxSizing === 'border-box' ? (parseFloat(cs.paddingTop) || 0) : 0));
      if (Math.abs(h - lastH) < 1) return;
      var first = !track.hasAttribute('data-autoh');
      if (first) track.setAttribute('data-autoh', 'off'); // primera medida sin transición (sin saltos en la carga)
      track.style.height = h + 'px'; lastH = h;
      if (first) requestAnimationFrame(function () { requestAnimationFrame(function () { track.setAttribute('data-autoh', ''); }); });
    }
    function queueFit() { if (!hRaf) hRaf = requestAnimationFrame(fitHeight); }
    if (autoH) {
      track.addEventListener('scroll', queueFit, { passive: true });
      if (window.ResizeObserver) { var ro = new ResizeObserver(queueFit); items.forEach(function (it) { ro.observe(it); }); }
      if (autoH.addEventListener) autoH.addEventListener('change', queueFit);
      window.addEventListener('orientationchange', function () { setTimeout(queueFit, 250); });
      queueFit();
    }
    window.addEventListener('resize', function () { buildDots(); update(); queueFit(); }, { passive: true });
    buildDots(); update();
  }

  /* ---------- Vídeos de testimonios: se cargan al pulsar ---------- */
  function initVideos(root) {
    $$('[data-cps-play]', root).forEach(function (b) {
      if (b.__cps) return; b.__cps = 1;
      b.addEventListener('click', function () {
        var box = b.closest('[data-cps-video]'); var tpl = box && $('template', box);
        if (!tpl) return;
        var v = tpl.content.querySelector('video').cloneNode(true);
        v.setAttribute('playsinline', ''); v.controls = true;
        // La portada (foto elegida o miniatura del vídeo) se mantiene como póster mientras el vídeo carga
        var img = $('img', box); if (img && (img.currentSrc || img.src)) v.setAttribute('poster', img.currentSrc || img.src);
        if (img) img.remove();
        box.insertBefore(v, b); box.classList.add('is-playing');
        $$('[data-cps-video].is-playing video').forEach(function (o) { if (o !== v) o.pause(); });
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      });
    });
  }

  /* ---------- Cronología: círculos y tarjetas al hacer scroll ---------- */
  function initTimeline(tl) {
    if (tl.__cps) return; tl.__cps = 1;
    // La línea termina en el centro del último círculo (no al final de la última tarjeta)
    var rail = $('.cps-tl__rail', tl), dots = $$('.cps-tl__dot', tl);
    function fitRail() {
      if (!rail || !dots.length) return;
      var tr = rail.parentNode.getBoundingClientRect(), last = dots[dots.length - 1].getBoundingClientRect();
      var top = parseFloat(getComputedStyle(rail).top) || 0;
      rail.style.bottom = 'auto';
      rail.style.height = Math.max(0, last.top + last.height / 2 - tr.top - top) + 'px';
    }
    fitRail();
    window.addEventListener('resize', fitRail, { passive: true });
    if (rail && window.ResizeObserver) new ResizeObserver(fitRail).observe(rail.parentNode);
    if (!tl.classList.contains('cps-tl--anim') || reduced || !('IntersectionObserver' in window)) return;
    var items = $$('[data-cps-tl-item]', tl);
    var fill = $('[data-cps-tl-fill]', tl);
    var track = $('.cps-tl__track', tl);
    tl.classList.add('is-armed');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-on'); io.unobserve(e.target); } });
    }, { rootMargin: '100000px 0px -35% 0px' });
    items.forEach(function (i) { io.observe(i); });
    var active = false, raf = 0;
    function draw() {
      raf = 0;
      var r = track.getBoundingClientRect();
      var p = (window.innerHeight * 0.65 - r.top) / Math.max(r.height, 1);
      tl.style.setProperty('--tl-p', Math.max(0, Math.min(1, p)).toFixed(3));
    }
    function onScroll() { if (active && !raf) raf = requestAnimationFrame(draw); }
    new IntersectionObserver(function (es) { active = es[0].isIntersecting; if (active) onScroll(); }).observe(tl);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (fill) draw();
  }

  /* ---------- Precio de la ficha = precio que Kaching muestra en la oferta elegida ----------
     Solo copia el texto ya calculado por Kaching (no calcula nada). Kaching haría esto mismo con su opción
     «actualizar precio nativo», que en esta tienda está desactivada y no se toca. */
  function syncPrice(k) {
    var sel = k.querySelector('.kaching-bundles__bar--selected') || k.querySelector('input:checked') && k.querySelector('input:checked').closest('.kaching-bundles__bar');
    if (!sel) return;
    var p = sel.querySelector('.kaching-bundles__bar-price');
    var f = sel.querySelector('.kaching-bundles__bar-full-price');
    var price = p ? p.textContent.trim() : '';
    var full = f ? f.textContent.trim() : '';
    if (!price) return;
    $$('[data-kaching-price]').forEach(function (n) { if (n.textContent.trim() !== price) n.textContent = price; });
    $$('[data-kaching-price-compare]').forEach(function (n) {
      if (full && full !== price) { if (n.textContent.trim() !== full) n.textContent = full; if (n.style.display !== '') n.style.display = ''; }
      else if (n.style.display !== 'none') n.style.display = 'none';
    });
  }

  /* ---------- Kaching: estado listo, etiqueta «Mejor valor» y comprobación de etiquetas de ahorro ----------
     Solo presentación: no cambia la selección, los precios ni la configuración de Kaching.
     - «Mejor valor»: por defecto se coloca en la oferta cuyo texto (nombre, subtítulo, insignias) incluye el texto
       configurado (p. ej. Kaching pone «Mejor Valor · Incluye regalos» en Pack Duo). Así sigue cada variante del test A/B.
     - Etiquetas de ahorro: el importe se compara con (tachado − precio) y con (tachado − precio + valor de los regalos).
       Si no coincide con ninguno, la etiqueta se oculta (atributo data-cps-save-bad) para no mostrar una cifra incorrecta. */
  function money(s) {
    var m = (s || '').replace(/\s/g, '').match(/\d[\d.,]*/);
    if (!m) return NaN;
    var v = m[0];
    if (v.indexOf(',') !== -1) v = v.replace(/\./g, '').replace(',', '.');
    return parseFloat(v);
  }
  function checkSavings(bar) {
    var label = bar.querySelector('.kaching-bundles__bar-label');
    if (!label) { bar.removeAttribute('data-cps-save-bad'); return; }
    var price = money((bar.querySelector('.kaching-bundles__bar-price') || {}).textContent);
    var full = money((bar.querySelector('.kaching-bundles__bar-full-price') || {}).textContent);
    var save = money(label.textContent);
    if (isNaN(save)) { bar.removeAttribute('data-cps-save-bad'); return; } // etiqueta sin importe (p. ej. un porcentaje de texto): no se juzga
    if (/%/.test(label.textContent)) { // porcentaje: se compara con el descuento sobre el tachado
      var okPct = !isNaN(price) && full > 0 && Math.abs(Math.round((1 - price / full) * 100) - save) <= 1;
      bar.toggleAttribute('data-cps-save-bad', !okPct); return;
    }
    var gifts = 0;
    Array.prototype.forEach.call(bar.querySelectorAll('.kaching-bundles__free-gift__full-price'), function (g) { var v = money(g.textContent); if (!isNaN(v)) gifts += v; });
    var base = !isNaN(full) && !isNaN(price) ? full - price : NaN;
    var ok = !isNaN(base) && (Math.abs(save - base) < 0.005 || Math.abs(save - (base + gifts)) < 0.005);
    if (isNaN(base) && gifts > 0) ok = Math.abs(save - gifts) < 0.005;
    bar.toggleAttribute('data-cps-save-bad', !ok);
  }
  /* Ahorro calculado: precio tachado − precio, ambos leídos de la propia oferta. Si falta el tachado o el resultado
     no es coherente (≤ 0, ≥ tachado, > 90 %), no se muestra nada. Formato español: 39,95 €. Solo presentación. */
  function calcSave(bar, tpl) {
    var price = money((bar.querySelector('.kaching-bundles__bar-price') || {}).textContent);
    var fullEl = bar.querySelector('.kaching-bundles__bar-full-price');
    var full = fullEl && fullEl.offsetParent !== null ? money(fullEl.textContent) : NaN;
    var save = Math.round((full - price) * 100) / 100;
    var ok = !isNaN(price) && !isNaN(full) && price > 0 && full > price && save >= 0.01 && save < full && save / full <= 0.9;
    var line = bar.querySelector('.kaching-bundles__bar-first-line');
    var tag = bar.querySelector('.cps-k-save');
    if (!ok || !line) { if (tag) tag.remove(); return; }
    var amount = save.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€';
    var text = (tpl || 'Ahorras [importe]').indexOf('[importe]') !== -1 ? (tpl || 'Ahorras [importe]').replace('[importe]', amount) : (tpl + ' ' + amount);
    if (!tag) { tag = document.createElement('span'); tag.className = 'cps-k-save'; }
    if (tag.textContent !== text) tag.textContent = text;
    var title = line.querySelector('.kaching-bundles__bar-title');
    var after = title ? title.nextSibling : null;
    if (tag.parentNode !== line || (title && tag.previousSibling !== title)) line.insertBefore(tag, after);
  }
  function initKaching(root) {
    $$('[data-cps-k]', root).forEach(function (k) {
      if (k.__cps) return; k.__cps = 1;
      var mode = k.getAttribute('data-tag-mode') || 'pos';
      var match = (k.getAttribute('data-tag-match') || '').trim().toLowerCase();
      var pos = parseInt(k.getAttribute('data-tag-pos'), 10) || 0;
      var label = k.getAttribute('data-tag-text') || '';
      var checkSave = k.getAttribute('data-check-save') === 'true';
      var saveMode = k.getAttribute('data-save-mode') || 'calc';
      var saveTpl = k.getAttribute('data-save-text') || '';
      function targetBar(bars) {
        if (mode === 'off' || !label) return null;
        if (mode === 'kaching') {
          if (!match) return null;
          for (var i = 0; i < bars.length; i++) {
            var txt = '';
            Array.prototype.forEach.call(bars[i].querySelectorAll('.kaching-bundles__bar-title, .kaching-bundles__bar-subtitle, .kaching-bundles__bar-second-line, .kaching-bundles__bar-label, [class*="most-popular"], [class*="bar-badge"]'), function (n) { txt += ' ' + n.textContent; });
            if (txt.toLowerCase().indexOf(match) !== -1) return bars[i];
          }
          return null;
        }
        return pos > 0 ? bars[pos - 1] || null : null;
      }
      function apply() {
        var bars = $$('.kaching-bundles__bar', k);
        if (!bars.length) return false;
        if (!k.classList.contains('is-ready')) k.classList.add('is-ready');
        syncPrice(k);
        if (saveMode === 'calc') bars.forEach(function (b) { calcSave(b, saveTpl); });
        else { $$('.cps-k-save', k).forEach(function (s) { s.remove(); }); if (saveMode === 'kaching' && checkSave) bars.forEach(checkSavings); }
        var bar = targetBar(bars), has = $('.cps-k-tag', k);
        if (has && has.parentNode !== bar) { has.parentNode.removeAttribute('data-cps-tagged'); has.remove(); has = null; }
        if (bar && !has && !bar.querySelector('[class*="most-popular"], [class*="bar-badge"]')) {
          var t = document.createElement('span'); t.className = 'cps-k-tag'; t.textContent = label;
          bar.setAttribute('data-cps-tagged', ''); bar.insertBefore(t, bar.firstChild);
        }
        return true;
      }
      var queued = 0;
      var mo = new MutationObserver(function () { if (queued) return; queued = requestAnimationFrame(function () { queued = 0; apply(); }); });
      mo.observe(k, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      k.addEventListener('change', function () { setTimeout(function () { syncPrice(k); }, 50); });
      apply();
      setTimeout(function () { if (!k.classList.contains('is-ready')) k.classList.add('is-ready'); }, 8000);
    });
  }

  /* ---------- Formulario: el mismo AJAX del tema ---------- */
  function initForms(root) {
    $$('form[data-cps-form]', root).forEach(function (form) {
      if (form.__cps) return; form.__cps = 1;
      var T = window.theme;
      if (T && T.AjaxProduct && T.settings && T.settings.cartType === 'drawer') {
        new T.AjaxProduct(form, '[data-cps-atc]');
        return;
      }
      if (T && T.settings && T.settings.cartType && T.settings.cartType !== 'drawer') return; // envío normal a /cart, como el tema
      // Respaldo (tema sin AjaxProduct): misma petición que Impulse
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-cps-atc]', form); if (btn) btn.classList.add('btn--loading');
        var body = new URLSearchParams(new FormData(form)).toString();
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', body: body, credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (btn) btn.classList.remove('btn--loading');
            if (data && data.status === 422) { var er = document.createElement('div'); er.className = 'errors'; er.textContent = data.description || data.message; form.appendChild(er); return; }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: btn } }));
          })
          .catch(function () { if (btn) btn.classList.remove('btn--loading'); form.submit(); });
      });
    });
  }

  /* ---------- Enlaces «comprar» → ofertas ---------- */
  function initToBuy() {
    if (document.__cpsToBuy) return; document.__cpsToBuy = 1;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-cps-to-buy]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href && href !== '#cps-comprar') return;
      var buy = document.getElementById('cps-comprar');
      if (!buy) return;
      e.preventDefault();
      var y = buy.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Barra fija ---------- */
  function initSticky() {
    var bar = $('[data-cps-sticky]');
    var atc = $('[data-cps-atc]') || $('[data-cps-buy]');
    if (!bar || !atc || bar.__cps || !('IntersectionObserver' in window)) return; bar.__cps = 1;
    new IntersectionObserver(function (es) {
      var e = es[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      var btn = $('a', bar); if (btn) btn.tabIndex = past ? 0 : -1;
    }, { rootMargin: '0px 0px 100000px 0px' }).observe(atc);
  }

  /* Ajusta el ancho de un texto partido en varias líneas a su línea más ancha (para que el icono quede junto al texto) */
  function fitText(el) {
    el.style.width = '';
    var r = document.createRange(); r.selectNodeContents(el);
    var rects = r.getClientRects(); if (!rects.length) return;
    var tops = {}, min = Infinity, max = 0, i;
    for (i = 0; i < rects.length; i++) { tops[Math.round(rects[i].top)] = 1; min = Math.min(min, rects[i].left); max = Math.max(max, rects[i].right); }
    if (Object.keys(tops).length > 1) el.style.width = Math.ceil(max - min + 1) + 'px';
  }
  function initFit(root) {
    var els = $$('[data-cps-fit]', root); if (!els.length) return;
    var run = function () { els.forEach(fitText); };
    run(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 120); });
  }

  /* Bloque de pago a plazos: si no muestra nada (p. ej. sin cuotas en el mercado), no deja hueco */
  function initTerms(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.cps-terms'), function (t) {
      var set = function () { t.classList.toggle('is-empty', t.offsetHeight < 2); };
      set(); if ('ResizeObserver' in window) new ResizeObserver(set).observe(t);
    });
  }

  /* Testimonios · móvil «Vídeo a la izquierda»: la reseña se corta a N líneas y «Leer más» la despliega.
     El botón solo aparece si el texto no cabe. La altura del carrusel se reajusta sola (ResizeObserver del carrusel). */
  function initReadMore(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.cps-tes--m-left'), function (sec) {
      if (sec.__cpsMore) return; sec.__cpsMore = 1;
      var more = sec.getAttribute('data-more') || 'Leer más', less = sec.getAttribute('data-less') || 'Leer menos';
      var mq = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
      var qs = Array.prototype.slice.call(sec.querySelectorAll('.cps-tes__it--card .cps-tes__q'));
      qs.forEach(function (q) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'cps-tes__more'; btn.hidden = true; btn.textContent = more;
        btn.setAttribute('aria-expanded', 'false'); q.parentNode.insertBefore(btn, q.nextSibling);
        btn.addEventListener('click', function () {
          var open = q.classList.toggle('is-open');
          btn.textContent = open ? less : more; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        q.__cpsBtn = btn;
      });
      function check() {
        qs.forEach(function (q) {
          var btn = q.__cpsBtn; if (!btn) return;
          if (!mq || !mq.matches) { btn.hidden = true; return; }
          if (q.classList.contains('is-open')) { btn.hidden = false; return; }
          btn.hidden = !(q.scrollHeight > q.clientHeight + 2);
        });
      }
      check(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
      var tm; window.addEventListener('resize', function () { clearTimeout(tm); tm = setTimeout(check, 150); });
    });
  }

  function initAll(root) {
    root = root || document;
    initBarCountdowns(); initCampaigns(); initShip(); initGallery(root); initKaching(root); initForms(root);
    $$('[data-cps-carousel]', root).forEach(initCarousel);
    $$('[data-cps-timeline]', root).forEach(initTimeline);
    initVideos(root); initToBuy(); initSticky(); initFit(root); initTerms(root); initReadMore(root);
  }

  /* Borradores: solo se muestran en el editor de temas o en la vista previa de un tema no publicado (nunca en el publicado) */
  try {
    var shp = window.Shopify || {};
    if (shp.designMode || (shp.theme && shp.theme.role && shp.theme.role !== 'main')) document.documentElement.classList.add('cps-preview');
  } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Editor de temas: volver a iniciar la sección que se recarga
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  // Al elegir un bloque en el editor, el carrusel se desplaza hasta él (si no, los bloques fuera de pantalla no se ven)
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target, track = el && el.closest && el.closest('[data-cps-track]');
    if (!track) return;
    var x = el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
    track.scrollTo({ left: Math.max(0, x), behavior: 'auto' });
  });
})();
